module.exports = __webpack_public_path__ + "static/media/04_plantilla_combo_rectangular_marco_comida_4.97d1ed46.png";